import React from 'react';
import styled, { css } from 'styled-components';

import { useMedia } from '@tager/web-core';

import SidePanelNew from '@/modules/DetailedCar/DetailedCarNew/components/SidePanelNew';
import { media } from '@/utils/mixin';

import FixedPreviewPanel from './components/FixedPreviewPanel';
import CarGallery from './components/CarGallery';
import MobileNavigation from './components/MobileNavigation';
import BaseSlider from './components/BaseSlider';
import FullSpecification from './components/FullSpecification';
import MoreDetails from './components/MoreDetails';
import PreviewSpecification from './components/PreviewSpecification';
import InfoMessage from './components/InfoMessage';
import TitleLinks from './components/TitleLinks';
import AdBanner from './components/AdBanner';
import AboutModel from './components/AboutModel';
import BlogBanner from './components/BlogBanner';

function DetailedCarNewMain() {
  const isTablet = useMedia('(max-width: 1259px)');

  return (
    <Component>
      {isTablet && <MobileNavigation />}
      {!isTablet && <TitleLinks />}
      <AboutModel />
      <CarGallery />
      {isTablet && <SidePanelNew />}
      <InfoMessage />
      <AdBanner />
      <PreviewSpecification />
      <BlogBanner />
      <FullSpecification />
      <MoreDetails />
      <BaseSlider />
      {isTablet && <FixedPreviewPanel />}
    </Component>
  );
}

export default DetailedCarNewMain;

const Component = styled.div`
  overflow: hidden;
  flex: 1 1 1px;

  ${media.tablet(
    css`
      width: 100%;
    `
  )}
`;
